export const API_TAGS = {
  BANNERS: "Banners",
  CURRENCIES: "Currencies",
  LANGUAGES: "Languages",
  LOCALIZATION: "Localization",
  PAYMENTS: "Payments",
  USER: "User",
};
